import React, { FC } from 'react';

import { ButtonType, Props } from './Button.type';

import './Button.scss';

const Button: FC<Props> = props => {
  const { active, primary, onClick, type, icon, className, ...rest } = props;
  const isActive = active !== undefined ? active : true;
  const isPrimary = primary !== undefined ? primary : true;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (isActive && onClick) {
      onClick(e);
    }
  };

  switch (type) {
    case ButtonType.I:
      return (
        <button
          className={`icon-button ${props.selected ? 'selected' : ''} ${className ?? ''}`}
          onClick={handleClick}
          {...rest}
        >
          {props.text ? <span>{props.text}</span> : null}
          <img src={icon} alt="icon-button" />
        </button>
      );
    case ButtonType.L:
      return (
        <button
          className={`line-button ${className ?? ''} ${isActive ? 'active' : 'disable'}`}
          onClick={handleClick}
          {...rest}
        >
          <span>{props.text}</span>
        </button>
      );
    default:
      return (
        <button
          onClick={handleClick}
          className={`default-button ${className ?? ''} ${isActive ? 'active' : 'disable'} ${
            isPrimary ? 'primary' : 'secondary'
          }`}
          {...rest}
        >
          {icon && <img src={icon} alt="icon-button" />}
          <span>{props.text}</span>
        </button>
      );
  }
};

export default Button;
